import type React from 'react'

import { AIMessageHeader } from '../AIMessageHeader'
import { MarkdownText } from '../MarkdownText'
import { MessageContainer } from '../MessageContainer'
import css from './styles.module.css'

interface AIMessageProps {
  children?: React.ReactNode
  isGenerating?: boolean
}

export const AIMessage: React.FC<AIMessageProps> = ({
  children = null,
  isGenerating = false,
}) => {
  return (
    <MessageContainer className={css.ai_chat_sidebar_message_ai}>
      {/* Status/loader stays ABOVE the text so it holds its place while the
          answer streams in below it (instead of sliding down). */}
      <AIMessageHeader isGenerating={isGenerating} />
      {children && (
        <div className={css.ai_chat_sidebar_message_ai_text}>
          {/* Assistant text is Markdown; render it. Non-string children
              (paywall/clarify wrappers) pass through untouched. */}
          {typeof children === 'string' ? (
            <MarkdownText>{children}</MarkdownText>
          ) : (
            children
          )}
        </div>
      )}
    </MessageContainer>
  )
}
